<template>
  <div>
    <b-row>
      <b-col
          md="2"
          sm="4"
          class="my-1"
      >
        <b-form-group
            class="mb-0"
        >
          <label class="d-inline-block text-sm-left mr-50">Anzeigen pro Seite</label>
          <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
              class="w-50"
          />
        </b-form-group>
      </b-col>
      <b-col
          md="4"
          sm="8"
          class="my-1"
      />

      <b-col
          md="6"
          class="my-1"
      >
        <b-form-group
            label="Filter"
            label-cols-sm="3"
            label-align-sm="right"
            label-size="sm"
            label-for="filterInput"
            class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
                id="filterInput"
                v-model="filter"
                type="search"
                placeholder="z.b. Name"
            />
            <b-input-group-append>
              <b-button
                  :disabled="!filter"
                  @click="filter = ''"
              >
                Leeren
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>

      </b-col>

      <b-col cols="12">
        <b-table
            hover
            responsive
            :per-page="perPage"
            :items="formartedItems"
            :fields="fields"
        >

          <template #cell(DateTime)="data">
            {{formatDate(data.item.DateTime)}}
          </template>
        </b-table>
      </b-col>

      <b-col
          cols="12"
      >
        <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="center"
            size="sm"
            class="my-0"
        />
      </b-col>
    </b-row>
  </div>

</template>

<script>

import {
  BTable, BAvatar, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BDropdown, BDropdownItem
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent'

export default {
  name: 'AccountLogs',
  components: {
    BDropdown,
    BDropdownItem,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      lastClickedRow: -1,
      perPage: 25,
      pageOptions: [10, 25, 50, 100],
      totalRows: 1,
      currentPage: 1,
      filter: null,
      filterTimeout: null,
      fields: [
        {
          key: 'DateTime',
          label: 'Zeit',
        },
        {
          key: 'Username',
          label: 'Benutzer',
        },
        {
          key: 'Text',
          label: 'Text',
        },
      ],
      items: [],
    }
  },
  computed: {

    formartedItems () {
      if (!this.items) return []
      return this.items.map(item => {
        item._rowVariant  = this.getVariant(item.DateTime)
        return item
      })
    }
  },
  sockets: {
    addSystemLog(log) {
      log._rowVariant  = this.getVariant(log.DateTime)
      this.items.unshift(log)
    },
  },
  mounted() {
    this.$nextTick(() => {
      document.title = 'Account. Logs'
    })
    this.$watch(
        () => this.filter,
        val => {
          const v = this
          if (this.filterTimeout) clearTimeout(this.filterTimeout)
          this.filterTimeout = setTimeout(() => {
            v.LoadList()
          }, 550)
        },
    )

    this.LoadList();
    setInterval(function(){
      this.UpdateColorRows();
    }.bind(this), 2500);

    this.$watch(
        () => this.perPage,
        val => {
          this.LoadList()
        },
    )
    this.$watch(
        () => this.currentPage,
        val => {
          this.LoadList()
        },
    )

  },
  methods: {
    UpdateColorRows() {
      for (let i = 0; i < this.items.length; i++) {
        console.log(this.items.length)
        if (new Date(this.items[i].DateTime) < new Date().setSeconds(new Date().getSeconds()-8)) {
          this.items[i]._rowVariant = "";
        }
      }
    },
    getVariant (logT) {
      if (new Date(logT) > new Date().setSeconds(new Date().getSeconds()-8)) {
        return 'info'
      }
    },
    formatDate(date) {
      return `${new Date(date).toLocaleString('de-DE', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
          },
      )}`
    },
    LoadList() {
      this.items = []
      const c1 = (this.currentPage - 1) * this.perPage
      let url = `/log/list?from=${c1}&count=${this.perPage}`
      if (this.filter && this.filter !== '') {
        url = `/log/list?from=${c1}&count=${this.perPage}&filter=${this.filter}`
      }
      this.$http.get(url)
          .then(resp => {
            console.log(resp)
            this.totalRows = resp.data.info.fullEntries
            resp.data.list.forEach(i => {
              i._rowVariant = "bg-success"
              this.items.push(i)
            })
          })
          .catch(err => {
            console.error(err)
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Fehler',
                icon: 'CheckIcon',
                text: err,
                variant: 'danger',
              },
            })
          })
    },
  },
}
</script>
